import React from 'react';
import {SidebarRightProducts} from 'shared/components/Header/SidebarRightProducts';
import {SidebarRightRoom} from 'shared/components/Header/SidebarRightRooms';
import {SidebarRightSundries} from 'shared/components/Header/SidebarRightSundries';
import {Icon} from 'shared/helpers';
import {useJobContext} from 'contexts/JobContext';
import SideBarRightFooter from 'shared/components/Header/SideBarRightFooter';
import {SidebarRightBenchtopModule} from 'shared/components/Header/SidebarRightBenchtopModule';
import {SecondaryActionButton} from 'shared/components/SecondaryButton';
import {useJobDialog} from 'components/customer/Job/helpers/useJobDialog';
import {VariationResetButton} from 'shared/components/Header/VariationResetButton';
import {SubmitButton} from 'shared/components/Header/SubmitButton';
import {PartialJob} from 'shared/types/PartialJob';
import {usePDFLinks} from 'shared/components/Header/helper/usePDFLinks';
import {PDFDropdown} from 'shared/components/Header/helper/PDFDropdown';
import {OverlayTrigger} from 'shared/components/OverlayTrigger';

export const CartContent = () => {
    const {job, actionButtonsEnabled} = useJobContext() as PartialJob;
    const {pdfDialog, pdfDropDown} = usePDFLinks();
    const {openJobDialog, jobDialog} = useJobDialog(true);

    return (
        <>
            <section className="sidebar-content">
                <div className="detail-export">
                    <div className="detail-export-info">
                        <div className="jobId jobInfoRow">
                            {`Job #${job.displayId ? job.displayId : ''}`}
                            {typeof job.id !== 'undefined' &&
                            actionButtonsEnabled &&
                            job.status != 5 ? (
                                <OverlayTrigger
                                    placement="right"
                                    overlay="Edit Job Details">
                                    <div>
                                        <SecondaryActionButton
                                            className="edit-job-details-button"
                                            onClick={openJobDialog}>
                                            <Icon iconName="Options-Edit.svg" />
                                        </SecondaryActionButton>
                                    </div>
                                </OverlayTrigger>
                            ) : null}
                        </div>
                        <div className="jobTitle">{job.name}</div>
                    </div>

                    <div className="detail-export-pdf">
                        <PDFDropdown
                            dialog={pdfDialog}
                            dropDowns={pdfDropDown}
                        />
                    </div>
                </div>

                {/* Right sidebar room table contents*/}
                <SidebarRightRoom />

                {/* Right sidebar product table contents*/}
                <SidebarRightProducts />

                {/* Right sidebar Benchtop Module table contents*/}
                <SidebarRightBenchtopModule />

                {/* Right sidebar Sundries table contents*/}
                <SidebarRightSundries />
            </section>
            <section className="sidebar-footer">
                <SideBarRightFooter />
                <SubmitButton />
                <VariationResetButton />
            </section>
            {jobDialog}
        </>
    );
};
